import React from 'react'
import _ from 'lodash'

export function Sidebar(props: React.HTMLProps<HTMLDivElement>) {
  const {className, ...rest} = props
  const classNames = _.chain(['sidebar', 'panel', className]).compact().join(' ').value()
  return (
    <div
      {...rest}
      className={classNames}
    />
  )
}

export * from './sidebars/components'
